import { generatePath } from 'react-router';
import { call, select, takeEvery } from 'redux-saga/effects';

import { PATH } from 'constants/RoutesConstants';
import { navigate } from 'modules/router/navigate';
import { getLocation } from 'modules/router/selectors';

import * as utils from '../utils';

const BLACKLIST_PATH = [PATH.GUIDELINES_DASHBOARD, PATH.CHECKLISTS, PATH.OFFERS_DASHBOARD, PATH.DEALER_MANAGEMENT];

/** @param {import('modules/global/generic.types').Action<import('axios').AxiosError<import('modules/global/generic.types').FleetbackApiError>>} action */
function* onErrorWatcher(action) {
  const { type, meta = {} } = action;

  // If it is a correct failure action, and the payload is an axios error
  const isError = type.endsWith('FAILURE');
  if (isError) {
    const error = utils.getActionPayloadError(action);
    console.log(error);
    const hasErrorPayload = error instanceof Error && error.isAxiosError;

    if (hasErrorPayload) {
      const isGet = error.config.method === 'get';
      // To be sure, we compare the url uuid entity to the request parameter
      // It's a way, for example, to not redirect the user, if the access on a checklist is refused, but the user is on the intervention details page
      const page = yield select(getLocation);
      const uuid = utils.extractUUIDParams(page.pathname) ?? utils.determinateId(page.pathname);
      // Split url to remove query params
      const sameEntity =
        Boolean(error.config.url && error.config.baseURL) &&
        new URL(`${error.config.baseURL}${error.config.url}`).pathname.endsWith(uuid);

      if ((sameEntity && isGet) || meta.redirectError) {
        const { data } = error.response ?? {};

        // The old endpoint doesn't return a data object
        const isNotFound = (!data && error.response?.status === 404) || utils.isNotFoundEntityError(data);
        const [parentRoute] = page.pathname.split(`/${uuid}`);
        const dashboard = utils.getParentPath(parentRoute, BLACKLIST_PATH);
        yield call(navigate, generatePath(isNotFound ? PATH.ERROR_404.path : PATH.ERROR_GLOBAL.path), { state: { dashboard } });
      }
    }
  }
}

export default function* errorSaga() {
  yield takeEvery('*', onErrorWatcher);
}
